import { supabase } from '@/lib/supabase';
import { getOpenState } from '@/lib/restaurantHours';

// ─────────────────────────────────────────────────────────────
// ZIFEK — État d'ouverture d'un commerce / vendeur.
//
// L'assistant IA vérifie qu'un commerce est OUVERT avant de mettre
// un de ses articles au panier (comme demandé). Les horaires sont
// lus dans `users.horaires_json` puis, à défaut, dans
// `merchant_home_config.opening_hours`.
//
// Sans horaires configurés, on considère le commerce ouvert (pas de
// blocage injustifié).
// ─────────────────────────────────────────────────────────────

export interface CommerceOpenState {
  open: boolean;
  /** Libellé des horaires du jour (ex. « 09:00 – 22:00 » ou « Fermé »). */
  todayLabel: string;
  /** De vrais horaires sont-ils configurés ? */
  hasHours: boolean;
}

const UNKNOWN: CommerceOpenState = { open: true, todayLabel: '', hasHours: false };

export async function fetchCommerceOpenState(commerceId: number | null | undefined): Promise<CommerceOpenState> {
  if (!commerceId || !Number.isFinite(commerceId)) return UNKNOWN;
  try {
    const { data: u } = await supabase
      .from('users')
      .select('horaires_json')
      .eq('id', commerceId)
      .maybeSingle();
    let hours: unknown = (u as { horaires_json?: unknown } | null)?.horaires_json ?? null;

    if (!hours) {
      const { data: cfg } = await supabase
        .from('merchant_home_config')
        .select('opening_hours')
        .eq('idcommerce', commerceId)
        .maybeSingle();
      hours = (cfg as { opening_hours?: unknown } | null)?.opening_hours ?? null;
    }

    if (!hours || typeof hours !== 'object' || Object.keys(hours as Record<string, unknown>).length === 0) {
      return UNKNOWN;
    }

    const state = getOpenState(hours);
    return { open: state.open, todayLabel: state.todayLabel, hasHours: true };
  } catch {
    return UNKNOWN;
  }
}